import JobSingleFetcher from "@/features/jobs/components/single/job.single.fetcher";
import JobSingleUI from "@/features/jobs/components/single/job.single.ui";
import { useJobListingStore } from "@/store/jobs/jobs.store";
import { FC, JSX } from "react";
import { useParams } from "react-router-dom";

const JobsSinglePage: FC = (): JSX.Element => {
  const { slug } = useParams();

  const jobListings = useJobListingStore((state) => state.jobListings);

  if (!slug) {
    return <div>Slug not found</div>;
  }

  if (!jobListings) {
    return <JobSingleFetcher slug={slug} />;
  }

  const data = jobListings.find((jobListings) => jobListings.slug === slug);

  if (!data) {
    return <div>Job listing not found</div>;
  }

  return <JobSingleUI {...data} />;
};

export default JobsSinglePage;
